import styled from 'styled-components';

export const TestCyclesOverviewFormStyled = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  box-sizing: border-box;
  padding: 24px 24px 24px 40px;
`;

export const TestCyclesOverviewFormHeaderStyled = styled.div`
  margin-bottom: 24px;
`;

export const TestCyclesOverviewFiltersStyled = styled.div`
  margin-bottom: 24px;
`;

export const TestCyclesOverviewContentStyled = styled.div`
  z-index: 1;
  height: 100%;
  flex: 1;
  margin-bottom: 24px;
`;

export const TestCyclesOverviewPaginationStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 32px;
`;
